import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './Counter.css';
import { MinusIcon } from './icons/MinusIcon';
import { PlusIcon } from './icons/PlusIcon';

interface ICounterProps {
  value: number;
  minValue?: number;
  maxValue?: number;
  onChange(value: number): void;
}

export const Counter = ({ value, minValue = 0, maxValue, onChange }: ICounterProps) => {
  const decrease = React.useCallback(() => {
    onChange(value - 1);
  }, [value, onChange]);

  const increase = React.useCallback(() => {
    onChange(value + 1);
  }, [value, onChange]);

  return (
    <div className={styles['wrapper']}>
      <button {...mergeStyles(styles['item'], styles['button'])} disabled={value === minValue} onClick={decrease}>
        <MinusIcon />
      </button>

      <div {...mergeStyles(styles['item'], styles['count'])}>{value}</div>

      <button {...mergeStyles(styles['item'], styles['button'])} disabled={value === maxValue} onClick={increase}>
        <PlusIcon />
      </button>
    </div>
  );
};
